import { ApiService } from "./ApiService"

export class GenieAcsService {

    static uri = '/acs';

    static get({ search, page, limit, sort, order }) {
        return ApiService.get(`${this.uri}`, {
            params: {
                search,
                page,
                limit,
                sort,
                order,
            }
        });
    }

    static getDeviceByIp({ ipAddress }) {
        return ApiService.get(`${this.uri}/get-device-by-ip?ip_address=${ipAddress}`);
    }
    
    static getDeviceById({ deviceId }) {
        return ApiService.get(`${this.uri}/get-device-by-id?device_id=${deviceId}`);
    }
    
    static addDeviceTag({ data }) {
        return ApiService.post(`${this.uri}/add-tag`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static updateWifiNetwork({ data , id}) {
        return ApiService.post(`${this.uri}/update-wifi/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static updatePppoeCofig({ data , id}) {
        return ApiService.post(`${this.uri}/update-pppoe/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static deleteDeviceTag({ data }) {
        return ApiService.post(`${this.uri}/delete-tag`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }
}